var exports = {
  "k": "x31de4314--732de4--container",
};

module.exports = exports;
